import styled from 'styled-components';

interface SizeProp {
  size: number | string;
}

export const CropperWrapper = styled.div<SizeProp>`
  width: ${props => props.size};
  height: ${props => props.size};
  border: 2px solid ${props => props.theme.color.wfGrey200};
  border-radius: 100%;

  position: relative;
  overflow: hidden;

  & .cropper {
    width: ${props => props.size};
    height: ${props => props.size};
  }
`;

export const Wrapper = styled.div<SizeProp>`
  width: ${props => props.size};
  height: ${props => props.size};
  border: 2px solid ${props => props.theme.color.wfGrey200};
  border-radius: 100%;

  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }
`;

export const InputFileStyled = styled.input`
  opacity: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: ${props => (props.disabled ? 'no-drop' : 'copy')};
  ::file-selector-button {
    display: none;
  }
`;
